import {Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';

@Component({
  selector: 'v-form-with-input',
  templateUrl: './form-with-input.component.html',
  styleUrls: []
})
export class FormWithInputComponent {
  constructor() {
    this.inputForm.valueChanges.subscribe(({input: _inputText}) => {
      this.showXBtn = !!_inputText.length;
    })
  }

  @ViewChild('input', {static: true})
  public input: ElementRef;

  @Output()
  public get keyupEvent(): Observable<string> {
    return this.inputControl.valueChanges;
  }

  public showXBtn: boolean;
  public focusClass: string;

  @Output()
  keyupEnterEvent: EventEmitter<any> = new EventEmitter();

  handleKeyDownEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.keyupEnterEvent.emit(null);
    }
  }

  changeActive() {
    this.focusClass = '--active';
  }

  changeActiveOff() {
    this.focusClass = '';
  }

  @Input()
  public set inputValue(name: string) {
    this.inputControl.patchValue(name,
      {
        emitEvent: false,
        emitModelToViewChange: true,
        emitViewToModelChange: true
      });
  }

  public INPUT_NAME = 'input';

  private inputControl = new FormControl('');
  public inputForm = new FormGroup({input: this.inputControl});

  @Input()
  public placeholderKey: string;

  @HostListener('searchboxclear')
  public clearInputField(): void {
    this.inputControl.reset('');
  }

  @HostListener('setfocus')
  public setFocus(): void {
    this.input.nativeElement.focus();
  }
}
